// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"0f601a5f","468":"563069e9","643":"d297b0f4","734":"a484f421","848":"081c3952"}[chunkId] + ".chunk.js";
};